///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../collections/service-categories.collection.ts"/>
///<reference path="../collections/services.collection.ts"/>
///<reference path="../collection-population-strategies/service-to-category.strategy.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class ServicesWithCategories extends DataTemplateBase implements IDataTemplate {

        protected serviceCategories: ServiceCategoriesCollection;
        protected services: ServicesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        get collection() {
            return this.serviceCategories;
        }

        get leafCollection()
        {
            return this.services;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[1]];
        }

        get totalSelectedCount(): number {
            return this.services.value.length;
        }

        constructor(model: Dictionary<any>, protected properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.serviceCategories = new ServiceCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
            });

            this.services = new ServicesCollection(this.model[properties[1]], [], {
                criteria: {
                    includeInactive: true,
                    ...options.criteria,
                },
            });

            this.services.setParentCollection(this.serviceCategories, CoreServiceToCategoryStrategy);
            if (this.model["showAllSelected"] == false) {
                this.showAllSelected = false;
            }
            
            this.title = 'SERVICES';
            this.allSelectedLabel = 'LABEL_ALL_SERVICES';
            this.totalSelectedMessage = 'LABEL_TOTAL_SERVICES_SELECTED';
            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_SERVICES' }, this)
            ];
            this.services.addFilters(...this.filters as IInteractiveFilter[]);

            if (options.required) {
                this.validation.push(new RequiredValidation(this.collection, 'LABEL_RESTRICT_SERVICE_FROM_TRANSFER_REQUIRED'));
            }
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.services.setWatchers(scope);
        }
    }
}